import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MediaPreviewItem from './MediaPreviewItem';

const MediaPreview = ({ 
  mediaFiles = [], 
  onRemove, 
  onReorder,
  uploadProgressMap = {} // 각 파일의 업로드 진행률 매핑
}) => {
  const theme = useTheme();
  const [draggedIndex, setDraggedIndex] = useState(null);

  if (mediaFiles.length === 0) {
    return null;
  }

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragEnd = (targetIndex) => {
    if (draggedIndex !== null && draggedIndex !== targetIndex && onReorder) {
      onReorder(draggedIndex, targetIndex);
    }
    setDraggedIndex(null);
  };

  const handleRemove = (index) => {
    if (onRemove) {
      onRemove(index);
    }
  };

  // 2xN 그리드 고정 (최대 2열)
  const getGridColumns = () => {
    return Math.min(2, mediaFiles.length);
  };

  return (
    <Box sx={{ mt: 2 }}>
      {/* 헤더 - 간소화 */}
      <Typography variant="subtitle2" color="text.primary" sx={{ mb: 1.5 }}>
        첨부된 미디어 ({mediaFiles.length}개)
      </Typography>

      {/* 미디어 그리드 */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: `repeat(${getGridColumns()}, 1fr)`, // 항상 그리드 모드
          gap: theme.spacing(1),
          height: 'auto', // 자연스러운 높이
          padding: theme.spacing(0.5),
          border: `1px solid ${theme.palette.grey[200]}`,
          borderRadius: theme.spacing(1),
          backgroundColor: theme.palette.grey[50],
          // 그리드 아이템 크기 제한
          '& > *': {
            maxWidth: '100%',
            width: '100%'
          }
        }}
      >
        {mediaFiles.map((file, index) => (
          <MediaPreviewItem
            key={`${file.name}-${index}`}
            file={file}
            index={index}
            onRemove={handleRemove}
            onReorder={{
              start: handleDragStart,
              end: handleDragEnd
            }}
            draggable={true}
            uploadProgress={uploadProgressMap[index]}
          />
        ))}
      </Box>

      {/* 추가 정보 */}
      <Box sx={{ mt: 1 }}>
        <Typography variant="caption" color="text.secondary">
          • 이미지와 비디오를 드래그하여 순서를 변경할 수 있습니다
        </Typography>
        {mediaFiles.length >= 20 && (
          <Typography variant="caption" color="warning.main" display="block">
            • 최대 20개 파일까지만 업로드 가능합니다
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default MediaPreview;